export default [
	{
		path: '/admin/settings',
		name: 'AdminSettings',
		component: () => import('../../views/admin/TenantSettings.vue'),
		meta: {layout: 'admin'}
	}
];